import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Voucher from "../components/User/Voucher";

export default withRouter(connect()(Voucher));
